import { Component } from '@angular/core';

@Component({
  templateUrl: './account-deleted.page.html',
})

/**
 * Account deleted confirmation page
 */
export class AccountDeletedPage {}
